import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { ScreenSizesType } from '../theme/screen-sizes.type';

export function useScreenSize() {
  const [width, setWidth] = useState<number>(window.innerWidth);

  const { screenSizes: themeScreenSizes } = useTheme();

  const screenSizes: Record<keyof ScreenSizesType, number> = {
    xs: parseInt(themeScreenSizes.xs, 10),
    sm: parseInt(themeScreenSizes.sm, 10),
    md: parseInt(themeScreenSizes.md, 10),
    lg: parseInt(themeScreenSizes.lg, 10),
    xl: parseInt(themeScreenSizes.xl, 10),
    xxl: parseInt(themeScreenSizes.xxl, 10),
  };

  const screenSize = Object.keys(screenSizes).find((key) => {
    const size = screenSizes[key as keyof ScreenSizesType];
    return width <= size;
  }) as keyof ScreenSizesType;

  useEffect(() => {
    const handleResize = () => {
      const { innerWidth } = window;
      setWidth(innerWidth);
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { width, screenSize, screenSizes };
}
